import { Storage } from './storage';
/**
 * Set flag GoTo in local Storage
 * @param {string} name Tenant's name
 */
export function setGoTo(name: string): void {
    Storage.setItem('goTo', `${name}@${Date.now().toString()}`);
}
